import { render } from "./PhotovoltaicView.vue?vue&type=template&id=bf72aaca"
const script = {}

import "./PhotovoltaicView.vue?vue&type=style&index=0&id=bf72aaca&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__